
import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot";
import axios from "axios";

export const getRolesLookUp = createAsyncThunk('/get-tele-sales', async () => {
    try {
        const response = await axios.get(`${baseUrl}cleaningappfunctions/crm/app/v1/get-tele-sales`,{page:1})
        console.log("response",response);
        
        return response
    } catch (error) {
        throw error
    }});